/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.search.no.auth.rpc.PublicSearchService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery } from 'data-fetching-client';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import * as References from './PublicSearchService';
const chirpClient = createRpcClientV2({
  hubHttpClient: noAuthHttp
});

/**
 * @deprecated due to potential cache collision issues. Use from the .dfc.new.ts file instead.
 * This will also change the data structure from 'data.fieldName' to 'data.result'.
 *
 * Recomended usage: Use hooks from .hooks.ts file instead.
 *
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.search.no.auth.rpc.PublicSearchService#search
 */
export const SEARCH_QUERY = /* #__PURE__ */registerQuery({
  fieldName: 'search',
  args: ['pageLength', 'search', 'sortingType', 'featuredHomepageOnly', 'featuredCertificationsOnly', 'hasAwardsOnly', 'shouldFilterDeprecated', 'levels', 'categories', 'hubSpotSoftware', 'contentTypes', 'durations', 'language', 'offset'],
  fetcher(request, ctx) {
    return chirpClient.call(References.searchRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});